import { render, staticRenderFns } from "./vLightswitch.vue?vue&type=template&id=399ca444&"
import script from "./vLightswitch.vue?vue&type=script&lang=js&"
export * from "./vLightswitch.vue?vue&type=script&lang=js&"
import style0 from "./vLightswitch.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports